export const getInitials = (str, maxChars = null, uppercase = true) => {
   const inits = str
      .split(" ")
      .map((n) => {
         if (!n[0]) return "";
         return uppercase ? `${n[0].toUpperCase()}` : `${n[0]}`;
      })
      .join("");

   if (maxChars) {
      return inits.slice(0, maxChars);
   }

   return inits;
};

export const formatPercent = (value, digit = 2) => {
   const formatter = new Intl.NumberFormat("it-IT", {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
      useGrouping: true,
   });
   return formatter.format(value) + `%`;
};

export const formatCurrency = (number, digits = 0, currency = "EUR") => {
   return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      useGrouping: true,
   }).format(number);
};

export const generateRandomPassword = (length, chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ") => {
   var password = "";
   for (var i = 0; i < length; i++) {
      const randomNumber = Math.floor(Math.random() * chars.length);
      password += chars.substring(randomNumber, randomNumber + 1);
   }

   return password;
};


export const generateChars = (fromChar, toChar) => {
   let chars = "";
   for (let i = fromChar.charCodeAt(0); i <= toChar.charCodeAt(0); i++) {
      chars += String.fromCharCode(i);
   }

   return chars;
}

export const randomId = (length = 6) => {
   const chars = generateChars("a", "z") + generateChars("A", "Z") + generateChars("0", "9");
   return generateRandomPassword(length, chars);
}

export const stringToColor = function (str) {
   let hash = 0;
   for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
   }
   let colour = "#";
   for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;
      colour += ("00" + value.toString(16)).substr(-2);
   }
   return colour;
};


export function uppercaseEveryWord(str) {
  return str
     .split(" ")
     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
     .join(" ");
}
